import { Link } from '@tanstack/react-router'

import type { FC } from 'react'

export const MenuListItem: FC<{
  linkUrl: string
  title: string
}> = ({ linkUrl, title }) => (
  <Link to={linkUrl}>
    <button className="cursor-pointer p-2 hover:bg-serblue-dark hover:text-[#D3D027]">
      <span className="h-6 inline-flex items-center">{title}</span>
    </button>
  </Link>
)

export const MenuListButton: FC<{
  title: string
  onClick: () => void
}> = ({ title, onClick }) => (
  <button
    onClick={onClick}
    className="cursor-pointer p-2 hover:bg-serblue-dark hover:text-[#D3D027]"
  >
    <span className="h-6 inline-flex items-center">{title}</span>
  </button>
)
